import type { BookEventPenalties } from './bookEvent.types';

export function studioHasPenalties(penalties: BookEventPenalties | null): boolean {
  return penalties?.NO_SHOW?.enabled === true || penalties?.LATE_CANCEL?.enabled === true;
}

function enabledPenalty(penalty: BookEventPenalties['NO_SHOW']) {
  return penalty?.enabled ? penalty : null;
}

function replacePolicyValues(
  template: string,
  values: Record<string, string | number | undefined>
): string {
  return Object.entries(values).reduce(
    (message, [key, value]) => message.replace(`{${key}}`, String(value)),
    template
  );
}

export function getAttendancePolicyMessage(args: {
  penalties: BookEventPenalties | null;
  cancelWindow: string | number | undefined;
  currencySymbol: string;
  translate: (key: string) => string;
}): string {
  if (!args.penalties) {
    return '';
  }
  const noShow = enabledPenalty(args.penalties.NO_SHOW);
  const lateCancel = enabledPenalty(args.penalties.LATE_CANCEL);
  if (noShow && lateCancel) {
    const key =
      noShow.fee === lateCancel.fee
        ? 'WEB_ATTENDANCE_POLICY_BOTH_SAME_FEE'
        : 'WEB_ATTENDANCE_POLICY_BOTH';
    return replacePolicyValues(args.translate(key), {
      'no-show-fee': args.currencySymbol + String(noShow.fee),
      'late-cancel-fee': args.currencySymbol + String(lateCancel.fee),
      cancelWindow: args.cancelWindow,
    });
  }
  if (noShow) {
    return replacePolicyValues(args.translate('WEB_ATTENDANCE_POLICY_NO_SHOW'), {
      'no-show-fee': args.currencySymbol + String(noShow.fee),
    });
  }
  if (lateCancel) {
    return replacePolicyValues(args.translate('WEB_ATTENDANCE_POLICY_LATE_CANCEL'), {
      'late-cancel-fee': args.currencySymbol + String(lateCancel.fee),
      cancelWindow: args.cancelWindow,
    });
  }
  return '';
}

export function translateOrFallback(
  translate: (key: string) => string,
  key: string,
  fallback: string
): string {
  const translated = translate(key);
  return !translated || translated === key ? fallback : translated;
}
